import ToggleButton from "../fields/ToggleButton";

interface StepEcheanceProps {
  value: string;
  onChange: (value: string) => void;
}

const OPTIONS = ["Dans les 3 mois", "Dans l'année", "Pas de date fixée"];

export default function StepEcheance({ value, onChange }: StepEcheanceProps) {
  return (
    <fieldset style={{ border: "none" }}>
      <legend
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 12,
          display: "block",
          width: "100%",
        }}
      >
        Quand souhaitez-vous réaliser vos travaux ?
      </legend>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
        }}
      >
        {OPTIONS.map((opt) => (
          <ToggleButton
            key={opt}
            label={opt}
            value={opt}
            active={value === opt}
            onClick={onChange}
            type="radio"
          />
        ))}
      </div>
    </fieldset>
  );
}
